export const state = function () {
  return {
    display: false,
    unlocked: false,
    timeout: null,
  }
}

export const mutations = {
  UNLOCK: function (state) {
    state.unlocked = true
    if (process.client) {
      if (state.timeout !== null) window.clearTimeout(state.timeout)
      state.timeout = window.setTimeout(() => {
        state.unlocked = false
      }, 1000 * 60 * 10)
      //10 minutes till unlock;
    }
  },
  LOCK: function (state) {
    state.unlocked = false
  },
  HIDE: function (state) {
    state.display = false
  },
  SHOW: function (state) {
    state.display = true
  },
}
